import React, { Component } from 'react';
import Sidebar from './Sidebar';
import store from '../../../store';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import { chunk } from '../../../helpers'
import Pagination from "react-js-pagination";
import {
    getConfimedCandidates, setConfirmedCandidates, getJobStatus, updatePlacementDetails
} from '../../../actions/employerAction'
import { Link } from 'react-router'

const RESULT_PER_PAGE = 25

const LOADER_DELAY_MS = 2000

class ConfirmedCandidates extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            selectedCandidate: null,
            placementForm: {
                placedment_date: '',
                placement_joining_date: '',
            },
            savingPlacement: false,
        }
        if (this.props.params && this.props.params.job_id) {
            store.dispatch(getConfimedCandidates(this.props.params.job_id, { loaderDelay: LOADER_DELAY_MS }));
        }
    }



    handlePageChange = (activePage) => {
        this.setState({ activePage: activePage })
    }




    componentWillUnmount() {
        store.dispatch(setConfirmedCandidates([]))
    }




    componentDidMount() {
        document.title = this.props.t('dashboard.table.noSelected', { param: 'react' })
        store.dispatch(getJobStatus())
    }

    getJobStatusText = (status) => {
        const matchedJob = this.props.EmployerReducer.jobStatus.filter(
            (job) => String(job.id) === String(status)
        )
        return matchedJob && matchedJob[0] ? matchedJob[0].name : ''
    }

    getTodayDateForInput = () => {
        const today = new Date()
        const year = today.getFullYear()
        const month = ('0' + (today.getMonth() + 1)).slice(-2)
        const day = ('0' + today.getDate()).slice(-2)
        return `${year}-${month}-${day}`
    }

    formatDateForInput = (dateStr) => {
        if (!dateStr) {
            return '';
        }

        const value = String(dateStr).split(' ')[0];

        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            return value;
        }

        if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
            const [day, month, year] = value.split('-');
            return `${year}-${month}-${day}`;
        }

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
            const [day, month, year] = value.split('/');
            return `${year}-${month}-${day}`;
        }

        return value;
    }

    getPlacementDate = (jobs) => {
        return this.formatDateForInput(
            jobs.placedment_date ||
            jobs.offer_date ||
            jobs.placement_date ||
            jobs.placed_on ||
            ''
        )
    }

    getJoiningDate = (jobs) => {
        return this.formatDateForInput(
            jobs.placement_joining_date ||
            jobs.joining_date ||
            jobs.date_of_joining ||
            ''
        )
    }

    getPlacementDateDisplay = (jobs) => {
        const date = this.getPlacementDate(jobs)
        return date && date !== '0000-00-00' ? date : 'NA'
    }

    getJoiningDateDisplay = (jobs) => {
        const date = this.getJoiningDate(jobs)
        return date && date !== '0000-00-00' ? date : 'NA'
    }

    openPlacementModal = (jobs) => {
        this.setState({
            selectedCandidate: jobs,
            placementForm: {
                placedment_date: this.getPlacementDate(jobs),
                placement_joining_date: this.getJoiningDate(jobs),
            },
        })
    }

    handlePlacementInput = (e) => {
        const { name, value } = e.target
        let nextValue = value

        if (name === 'placedment_date' && value && value > this.getTodayDateForInput()) {
            nextValue = this.getTodayDateForInput()
        }

        this.setState({
            placementForm: {
                ...this.state.placementForm,
                [name]: nextValue,
            },
        })
    }

    savePlacementDetails = () => {
        const { selectedCandidate, placementForm, savingPlacement } = this.state
        const job_id = this.props.params && this.props.params.job_id
        const user_id = selectedCandidate && (
            selectedCandidate.applied_user_id ||
            selectedCandidate.user_id ||
            selectedCandidate.id
        )

        if (savingPlacement || !job_id || !user_id) {
            return
        }

        this.setState({ savingPlacement: true })

        store.dispatch(updatePlacementDetails({
            job_id,
            user_id,
            offer_date: placementForm.placedment_date || this.getPlacementDate(selectedCandidate),
            placement_joining_date: placementForm.placement_joining_date,
            placement_status: selectedCandidate.placement_status || 1,
        }, { loaderDelay: LOADER_DELAY_MS }))
            .then((resp) => {
                const isSuccess =
                    resp &&
                    resp.data &&
                    (resp.data.status === '200' ||
                        resp.data.status === 200 ||
                        resp.data.status === true)

                if (isSuccess) {
                    document.getElementById('closePlacementModalBtn').click()
                }
            })
            .catch(() => {})
            .finally(() => {
                this.setState({ savingPlacement: false })
            })
    }



    render() {
        let Mainprops = this.props;

        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }


        let searchResults = chunk(Mainprops.EmployerReducer.confirmedCandidates, RESULT_PER_PAGE)
        const { activePage, placementForm, savingPlacement } = this.state


        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">
                <div className="modal fade" id="placementDetailsModal" tabIndex="-1" role="dialog" aria-labelledby="placementDetailsModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header align-items-center d-flex">
                                <h4 className="modal-title font-weight-bold mb-0 flex-grow-1" id="placementDetailsModalLabel">
                                    Placement details
                                </h4>
                                <button
                                    type="button"
                                    className="btn btn-light rounded-circle border-0 d-flex align-items-center justify-content-center flex-shrink-0 ms-2"
                                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="fa fa-times text-secondary" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>{this.props.t('dashboard.table.placement_date', { param: 'react' })}</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="placedment_date"
                                        value={placementForm.placedment_date || ''}
                                        max={this.getTodayDateForInput()}
                                        onChange={this.handlePlacementInput}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>{this.props.t('experience.Joining Date', { param: 'react' })}</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="placement_joining_date"
                                        value={placementForm.placement_joining_date || ''}
                                        onChange={this.handlePlacementInput}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    id="closePlacementModalBtn"
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-primary2"
                                    onClick={this.savePlacementDetails}
                                    disabled={savingPlacement}
                                >
                                    {savingPlacement ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        {Sidebar ? <Sidebar route={Mainprops.route} /> : ''}


                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="clearfix"></div>
                            <div id="home" className=" tab-pane active">
                                <section className="job-details mt-4">
                                    <div className="container">
                                        <div className="row">

                                            <div className="col-md-12  mx-auto  tab-content  p-0">

                                                <div className="panel-heading">
                                                    <h6 className="mb-0">{this.props.t('dashboard.table.noSelected', { param: 'react' })}</h6>

                                                </div>
                                                <div className="panel-body">
                                                    <div className="row pl-3 pr-3">
                                                        {Mainprops.EmployerReducer.confirmedCandidates && Mainprops.EmployerReducer.confirmedCandidates.length ?
                                                            <>
                                                                <h6 className="mr-3">{this.props.t('dashboard.table.job-title', { param: 'react' })}: <b>{Mainprops.EmployerReducer.confirmedCandidates[0].job_title}</b></h6>
                                                                <h6 className="mr-3">{this.props.t('dashboard.table.vacancies', { param: 'react' })}: <b>{Mainprops.EmployerReducer.confirmedCandidates[0].vacancies}</b></h6>
                                                                <h6 className="mr-3">{this.props.t('jobSearch.qual', { param: 'react' })}: <b>{Mainprops.EmployerReducer.confirmedCandidates[0].qualification}</b></h6>
                                                            </> : null
                                                        }
                                                    </div>
                                                    <hr></hr>
                                                    <div className="row pl-3 pr-3">
                                                        <div className="table-responsive">
                                                            <table className="table table-hover table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>{this.props.t('dashboard.table.sr_no', { param: 'react' })}</th>
                                                                        <th>{this.props.t('dashboard.table.name', { param: 'react' })}</th>
                                                                        <th>{this.props.t('dashboard.table.gender', { param: 'react' })}</th>
                                                                        <th>{this.props.t('dashboard.table.education', { param: 'react' })}</th>
                                                                        <th>{this.props.t('JobPost.district', { param: 'react' })}</th>
                                                                        <th>{this.props.t('JobPost.email', { param: 'react' })}</th>
                                                                        <th>{this.props.t('JobPost.exp1', { param: 'react' })}</th>
                                                                        <th>{this.props.t('dashboard.table.mobile', { param: 'react' })}</th>
                                                                        <th>Job Status</th>
                                                                        <th>{this.props.t('dashboard.table.placement_date', { param: 'react' })}</th>
                                                                        <th>{this.props.t('experience.Joining Date', { param: 'react' })}</th>
                                                                        <th>Placement Details</th>
                                                                    </tr>

                                                                </thead>
                                                                <tbody>
                                                                    {searchResults && searchResults.length > 0 && searchResults[activePage - 1].map((jobs, key) => {

                                                                        return (<tr key={key}>
                                                                            <td>{((activePage - 1) * RESULT_PER_PAGE) + key + 1}</td>
                                                                            <td>
                                                                                <span


                                                                                >{jobs.firstname ? jobs.firstname : ''}</span>


                                                                            </td>
                                                                            <td>{jobs.gender ? jobs.gender : ''}</td>
                                                                            <td>{jobs.education ? jobs.education : ''}</td>
                                                                            <td>{jobs.district ? jobs.district : ''}</td>
                                                                            <td className="nowrapclassa">{jobs.email ? jobs.email : ''}</td>
                                                                            <td>{jobs.experience ? jobs.experience : ''}</td>
                                                                            <td>{jobs.mobile ? jobs.mobile : ''}</td>
                                                                            <td>{this.getJobStatusText(jobs.job_status)}</td>
                                                                            <td>{this.getPlacementDateDisplay(jobs)}</td>
                                                                            <td>{this.getJoiningDateDisplay(jobs)}</td>
                                                                            <td>
                                                                                <span
                                                                                    className="date-clr"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    data-toggle="modal"
                                                                                    data-target="#placementDetailsModal"
                                                                                    onClick={() => this.openPlacementModal(jobs)}
                                                                                    role="button"
                                                                                    tabIndex={0}
                                                                                    aria-label="View placement details"
                                                                                >
                                                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                                                </span>
                                                                            </td>
                                                                        </tr>)
                                                                    })}
                                                                    {Mainprops.EmployerReducer.confirmedCandidates.notFound &&
                                                                        <tr>
                                                                            <td colSpan="12" style={{ "textAlign": "center" }}>
                                                                                <h5>{this.props.t('JobPost.notFound', { param: 'react' })}</h5></td>
                                                                        </tr>}


                                                                </tbody>

                                                            </table>
                                                            {searchResults && searchResults.length > 1 ?
                                                                <div className='react-pagination'>
                                                                    <Pagination
                                                                        pageRangeDisplayed={10}
                                                                        activePage={activePage}
                                                                        itemsCountPerPage={RESULT_PER_PAGE}
                                                                        totalItemsCount={Mainprops.EmployerReducer.confirmedCandidates.length}
                                                                        onChange={this.handlePageChange}
                                                                    />
                                                                </div> : ''}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </main>
                    </div>
                </div>
            </section>)
    }
}

const mapStateToProps = store => {
    return store;
};
export default connect(mapStateToProps)(translate(ConfirmedCandidates));
